import React from 'react';
import InternalPageLayout from '../components/InternalPageLayout';
import { Tractor, Clock } from 'lucide-react';

export default function FarmersPage() {
  return (
    <InternalPageLayout
      title="For Farmers"
      subtitle="Coming Soon"
      breadcrumbs={[
        { label: 'For Farmers' }
      ]}
    >
      <div className="flex flex-col items-center justify-center py-20">
        <div className="bg-gradient-to-br from-[#0E6D2B]/10 to-[#21A366]/10 rounded-full p-8 mb-6">
          <Tractor className="w-24 h-24 text-[#0E6D2B]" />
        </div>
        <h2 className="text-3xl font-bold text-gray-800 mb-3">Farmers Portal</h2>
        <p className="text-lg text-gray-600 mb-4 flex items-center gap-2">
          <Clock className="w-5 h-5" />
          Coming Soon
        </p>
        <p className="text-gray-600 text-center max-w-md">
          We're developing a dedicated portal for farmers with resources, advisories, 
          and services. Stay tuned!
        </p>
        <div className="mt-8 flex gap-4">
          <a 
            href="/agro-advisory" 
            className="px-6 py-3 bg-[#0E6D2B] text-white rounded-lg hover:bg-[#0a5a23] transition-colors"
          >
            Agro Advisory
          </a>
          <a 
            href="/nursery" 
            className="px-6 py-3 border-2 border-[#0E6D2B] text-[#0E6D2B] rounded-lg hover:bg-[#0E6D2B] hover:text-white transition-colors"
          >
            Visit Nursery
          </a>
        </div>
      </div>
    </InternalPageLayout>
  );
}
